import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

// 获取需审批的订单列表
export const getOrderList = (params: any) =>
  request({
    url: '/manage/deposit-review-task',
    method: 'get',
    params
  })

// 审批订单
export const auditOrder = (data: any) =>
  request({
    url: '/manage/deposit-review-task/' + data.task_id,
    method: 'put',
    data
  })

// 导出
export const tableExport = (data: any) =>
  request({
    url: '/manage/deposit-review-task/export' + objToUrlParams(data),
    method: 'post'
  })

// 入金批量审批
export const setBatchReview = (data: any) =>
  request({
    url: '/manage/deposit-review-task/batch-review',
    method: 'post',
    data
  })


// 管理员批量审核
export const setBatchAdminAudit = (data: any) =>
  request({
    url: '/manage/manager-review-task/batch-check',
    method: 'post',
    data
  })
